module.exports = __webpack_public_path__ + "static/home2-b22f43b3cacda5ba9491450fec5fde13.jpg";